import { LoadingService } from '../../../../shared/services/loading/loading.service';

export const automationLoadingService = new LoadingService();
